import React from 'react'
import { useTranslation } from 'react-i18next'
import CustomModal from '../../CustomModal'
import Button from '../../../buttons/Button'
import { useOrderInvoice } from '../../../table/InvoicesTable/hooks/useOrderInvoice'
import { getInvoiceViewStatus, INVOICE_STATUS } from '../../../table/InvoicesTable/constants'
import OrderModalDescription from '../OrderModalDescription'

const EVENT_Z_INDEX = 128

const ChangePaymentConfirmModal = React.memo(({ isOpen = false, close, onConfirm, order }) => {
	const { t } = useTranslation()
	const { invoice } = useOrderInvoice(order?.orderId, isOpen)
	const isInvoicePaid = !!invoice && getInvoiceViewStatus(invoice) === INVOICE_STATUS.PAID

	return (
		<CustomModal isOpen={isOpen}
								 id="change-payment-confirm-modal"
								 size="small"
								 close={close}
								 title={t('order.modal.changePaymentModal.title')}
								 disableBackButton={true}
								 zIndex={EVENT_Z_INDEX}
								 returnZIndex={0}
								 button={
									 <>
										 <Button name="cancel" icon="back" text={t('Modal.cancel')} keyButton="F3" zIndex={EVENT_Z_INDEX} onClick={close} className="back" />
										 <Button name="accept" icon="checkmark" text={t('Modal.accept')} color="green" keyButton="F2" zIndex={EVENT_Z_INDEX} onClick={onConfirm} />
									 </>
								 }>
			<OrderModalDescription title={t('order.modal.changePaymentModal.descriptionTitle')}
														 text={t(isInvoicePaid ? 'order.modal.changePaymentModal.descriptionPaid' : 'order.modal.changePaymentModal.descriptionUnpaid')} />
		</CustomModal>
	)
})

ChangePaymentConfirmModal.displayName = 'ChangePaymentConfirmModal'
export default ChangePaymentConfirmModal
